module.exports = __webpack_public_path__ + "img/logo1.d8d785a2.png";